export default __webpack_public_path__ + "static/media/getStart.f4bee2aa.svg";